<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import useUiStore from '../../stores/ui';
import useLocale from '../../composables/useLocale';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faListMusic, faListTree } from '@fortawesome/pro-regular-svg-icons';

library.add([faListMusic, faListTree]);

type Props = {
  showTooltips: boolean;
};
defineProps<Props>();

const uiStore = useUiStore();
const { isTimeBasedSeekingVisible } = storeToRefs(uiStore);
const { toggleVisibleTimeBasedSeeking } = uiStore;
const { t } = useLocale();

const handleToggle = () => {
  toggleVisibleTimeBasedSeeking(!isTimeBasedSeekingVisible.value);
};
</script>

<template>
  <v-btn
    data-testid="bp-seeking-mode-toggle-btn"
    icon
    variant="text"
    rounded="lg"
    color="on-surface"
    @click="handleToggle"
    :aria-label="
      isTimeBasedSeekingVisible
        ? t('book_player.label_switch_to_track_seeking')
        : t('book_player.label_switch_to_time_seeking')
    "
  >
    <FontAwesomeIcon size="xl" :icon="isTimeBasedSeekingVisible ? 'far fa-list-tree' : 'far fa-list-music'" />
    <v-tooltip
      activator="parent"
      location="bottom"
      :text="isTimeBasedSeekingVisible ? t('book_player.label_track_seeking') : t('book_player.label_time_seeking')"
      :disabled="!showTooltips"
    />
  </v-btn>
</template>
